import { Button } from "primereact/button";
import React, { useState } from "react";
import { dateToDMY, formatSparkTime, getDateOffsetByDays } from "../../utils/dateUtils";
import { Calendar } from "primereact/calendar";
import { useGet } from "../../network/useGet";
import NetworkWrapper from "../NetworkWrapper";
import BaseTableView from "../cmsbase/BaseTableView";
import { eventBookingsTableFields, eventsTableFields } from "../../network/mockData";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { getTranslation } from "../../utils/translationUtils";

const INITIAL_FORM_DATA = {
  fromDate: getDateOffsetByDays(0), 
  toDate: getDateOffsetByDays(7),
};

const ExternalEvents = () => {

  const [filterString, setFilterString] = useState(
    `fromDate=${dateToDMY(INITIAL_FORM_DATA.fromDate)}&toDate=${dateToDMY(INITIAL_FORM_DATA.toDate)}`
  );
  const [ selectedId, setSelectedId ] = useState(null);
  const [ showDetails, setShowDetails ] = useState(false);


  const url = "external/admin/events?" + filterString;

  const { isLoading, error, data } = useGet(url);

  const getHeader = () => {
    if(!selectedId) return "";
    
    const event = data.find(event => event.id === selectedId);
    const startTime = formatSparkTime(event.details.startTime);
    const endTime = formatSparkTime(event.details.endTime);

    return (
      <>
        <p>Event: {getTranslation(event.details.name)}</p>
        <p>Venue: {getTranslation(event.details.venue)}</p>
        <p>Date & Time: {`${event.startDate} ${startTime} ${endTime ?  " - " + endTime : ""}`}</p>
      </>
    );
  }

  const customColumn = (key, rowData) => {
    switch (key) {
      case "name":
        return <p>{getTranslation(rowData.details.name)}</p>
      case "venue":
        return <p>{getTranslation(rowData.details.venue)}</p>;
      case "timings":
        const startTime = formatSparkTime(rowData.details.startTime);
        const endTime = formatSparkTime(rowData.details.endTime);
        
        return <p>{`${startTime} ${endTime ? `-${endTime}` : ""}`}</p>
    
      default:
        return <p>{`Implement the case for ${key} in ExternalEvents.js`}</p>;
    }
  }

  return (
    <div className="max-w-full">
      <FilterForm
        setFilterString={setFilterString}
        isLoading={isLoading}
      />
      <NetworkWrapper isLoading={isLoading} error={error}>
        {data && (
          <div>
            <BaseTableView
              data={data}
              tableFields={eventsTableFields}
              globalFilter={true}
              selectedId={selectedId}
              setSelectedId={setSelectedId}
              setShowForm={setShowDetails}
              customColumn={customColumn}
              emptyMessage="No Events found for the Selected Criteria."
            />
          </div>
        )}
      </NetworkWrapper>
      <ConfirmDialog />

      <Dialog
        visible={showDetails}
        blockScroll
        header={getHeader()}
        style={{ width: '80vw' }}
        footer={(<Button label="Close" icon="pi pi-times" onClick={() => {setShowDetails(false); setSelectedId(null)}} className="p-button-text" />)}
        onHide={() => {setShowDetails(false); setSelectedId(null)}}
        baseZIndex={1000}
    >
        {selectedId &&
            <Bookings event={data.find(event => event.id === selectedId)} />
        }
    </Dialog>
    </div>
  );
};

const FilterForm = ({ setFilterString, isLoading }) => {
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const onChangeFormField = (event) => {
    const name = event.target ? event.target.name : event.originalEvent.target.name;
    const value = event.target ? event.target.value : event.value;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const updateFilterString = (formData) => {

    const urlParams = Object.entries(formData)
    .filter(([key, value]) => !!value)
    .map(([key, value]) => `${key}=${value instanceof Date ? dateToDMY(value) : value}`)
    .join('&');

    setFilterString(urlParams);
  };

  return (
    <div className="px-4 py-8 border-b-2 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">

      {/* From date */}
      <div>
        <label htmlFor="date-from-input">
          <span className="pr-2">From Date</span>
        </label>
        <div>
          <Calendar
            inputId="date-from-input"
            name="fromDate"
            dateFormat="dd/mm/yy"
            value={formData.fromDate}
            onChange={onChangeFormField}
            className="w-9/12 max-w-9/12"
            minDate={new Date()}
            disabled={isLoading}
          />
        </div>
      </div>

      {/* toDate */}
      <div>
        <label htmlFor="date-to-input">
          <span className="pr-2">To Date</span>
        </label>
        <div>
          <Calendar
            inputId="date-to-input"
            name="toDate"
            dateFormat="dd/mm/yy"
            value={formData.toDate}
            onChange={onChangeFormField}
            className="w-9/12 max-w-9/12"
            minDate={new Date(formData.fromDate)}
            disabled={isLoading}
          />
        </div>
      </div>

      <div className="flex gap-2 justify-start items-end md:col-span-2">
        {/* Get Data */}
        <Button
          label="Get Events"
          onClick={() => updateFilterString(formData)}
          disabled={isLoading}
        />

      </div>
    </div>
  );
};

const Bookings = ({event}) => {
    const url = `external/admin/events/${event.id}`;
    const { isLoading, error, data } = useGet(url);

    return(
      <NetworkWrapper isLoading={isLoading} error={error}>
        {data && (
          <div>
            <BaseTableView
              data={data}
              tableFields={eventBookingsTableFields}
              globalFilter={true}
              emptyMessage="No Bookmarks found."
            />
          </div>
        )}
      </NetworkWrapper>
    )
}

export default ExternalEvents;
